import React from 'react';
import { useIntl } from 'react-intl';
import clsx from "clsx";
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { DeliveryGraph } from '../dashboard/DeliveryGraph';
import PaperCard from './paper-card';

const useStyles = makeStyles(theme => ({
  header: {
    color: 'rgb(182, 193, 220)',
    fontSize: 18, 
    padding: theme.spacing(1, 0),
    fontWeight: 600
  },
  subHeader: {
    color: 'rgb(255, 255, 255)',
    fontWeight: 600
  },
  deliveryPercent: {
    width: 100,
    padding: theme.spacing(0, 1.5),
    backgroundColor: 'rgb(240,11,63)',
    borderRadius: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems:'center',
    fontSize: 20,
    color: 'rgb(255,255,255)'
  },
  height: {
    height: 400
  },
  darkMode: {
    color: '#000',
  }
}));

export default function Delivery({theme}) {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const children = (
    <div>
      <Typography variant="h5" component="p" className={classes.header}>
        {formatMessage({id:"app.subHeader.dashboard.maintopic", defaultMessage: "Main topic"})}
      </Typography>
      <Box display='flex' justifyContent='space-between' marginBottom={!theme ? 2 : 0}>
        <Typography variant="h4" component="p" classes={{root: clsx(classes.subHeader, !theme ? classes.darkMode : null)}}>
        {formatMessage({id:"app.subHeader.dashboard.delivery", defaultMessage: "Delivery"})}
        </Typography>
        <Paper className={classes.deliveryPercent}>
          +12,6%
        </Paper>
      </Box>
      <Box>
      <DeliveryGraph />
      </Box>
    </div>
  )
  return (
    <PaperCard
      children={children}
      height={classes.height} 
      theme={theme}
    />
  );
}
